import {Component, h} from "preact";
import {MarkerList} from "./MarkerPositioning/MarkerList";
import {MarkerPreview} from "./MarkerPositioning/MarkerPreview";
import fetch from "mojave/polyfill/fetch";


/**
 * @typedef {{
 *      previewUrl: string,
 *      updateUrl: string,
 *      markers: MarkerPositioning.Marker[],
 * }} MarkerPositioning.Props
 *
 * @typedef {{
 *      hoveredMarker: ?MarkerPositioning.Marker,
 *      isLoading: boolean,
 * }} MarkerPositioning.State
 *
 * @typedef {{
 *     id: string,
 *     type: string,
 *     placeholderContent: ?string,
 *     label: string,
 *     x: ?number,
 *     y: ?number,
 * }} MarkerPositioning.Marker
 */
export class MarkerPositioning extends Component
{
	/**
	 * @private
	 * @type {?number}
	 */
	loadingTimer = null;


	/**
	 * @param {MarkerPositioning.Props} props
	 */
	constructor (props)
	{
		super(props);
		this.state = {
			hoveredMarker: null,
			isLoading: false,
		};
	}

	/**
	 * @param {MarkerPositioning.Props} props
	 * @param {MarkerPositioning.State} state
	 * @returns {null|JSX.Element}
	 */
	render (props, state)
	{
		return (
			<div class="contract-marker-positioning">
				<MarkerPreview
					markers={props.markers}
					previewUrl={props.previewUrl}
					hovered={state.hoveredMarker}
					onHoverEnter={marker => this.setHoveredMarker(marker)}
					onHoverLeave={() => this.setHoveredMarker(null)}
					onMarkerPositioned={(marker, x, y) => this.positionMarker(marker, x, y)}
				/>
				<div class="marker-positioning-catalog">
					<div class="card">
						<div class="card-body">
							<h3 class="card-title">Markierungen</h3>
						</div>
						<MarkerList
							markers={props.markers}
							hovered={state.hoveredMarker}
							onHoverEnter={marker => this.setHoveredMarker(marker)}
							onHoverLeave={() => this.setHoveredMarker(null)}
							onMarkerClick={marker => this.toggleMarkerActivation(marker)}
						/>
					</div>
				</div>
				<div class="marker-positioning-disabled">
					<div class="alert alert-warning">
						<p>Die PDF-Markierungen können nur auf einem ausreichend großen Monitor gesetzt werden.</p>
						<p>Bitte vergrößern Sie das Browserfenster oder wechseln das Gerät um die Markierungen zu
							setzen.
						</p>
					</div>
				</div>
				{state.isLoading && (
					<div class="marker-positioning-loading">
						<div className="progress">
							<div
								className="progress-bar progress-bar-striped progress-bar-animated"
								style="width: 100%"
							/>
						</div>
						<p>Speichert...</p>
					</div>
				)}
			</div>
		);
	}


	/**
	 * @private
	 * @param {MarkerPositioning.Marker} marker
	 */
	toggleMarkerActivation (marker)
	{
		if (marker.x !== null)
		{
			this.positionMarker(marker, null, null);
		}
		else
		{
			this.positionMarker(marker, 0, 0);
		}
	}


	/**
	 * Positions the marker at the given position
	 *
	 * @private
	 * @param {MarkerPositioning.Marker} marker
	 * @param {?number} x
	 * @param {?number} y
	 */
	positionMarker (marker, x, y)
	{
		marker.x = x;
		marker.y = y;

		this.setLoading(true);

		fetch(this.props.updateUrl, {
			method: "post",
			credentials: "include",
			cache: "no-cache",
			body: JSON.stringify({
				id: marker.id,
				x: x,
				y: y,
			}),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		})
			.then(response => response.json())
			.then(
				data => this.onResponse(data),
				() => this.onRequestFailure()
			);

		this.forceUpdate();
	}


	/**
	 * @private
	 * @param {{status: string}} data
	 */
	onResponse (data)
	{
		if ("ok" === data.status)
		{
			this.setLoading(false);
			return;
		}

		this.onRequestFailure();
	}


	/**
	 * @private
	 */
	onRequestFailure ()
	{
		alert("Die Anfrage ist leider fehlgeschlagen. Bitte laden Sie die Seite neu und versuchen es noch einmal.");
	}


	/**
	 * @private
	 * @param {?MarkerPositioning.Marker} hoveredMarker
	 */
	setHoveredMarker (hoveredMarker)
	{
		this.setState({hoveredMarker});
	}


	/**
	 * Handles displaying the loading message.
	 * The message is only displayed if loading takes longer than 250ms
	 *
	 * @param {boolean} isLoading
	 */
	setLoading (isLoading)
	{
		if (!isLoading)
		{
			window.clearTimeout(this.loadingTimer);
			this.setState({isLoading: false});
			return;
		}

		this.loadingTimer = window.setTimeout(
			() =>
			{
				this.loadingTimer = null;
				this.setState({isLoading: true});
			},
			250
		);
	}
}
